import PropTypes from 'prop-types';
import { Box, FormControl, MenuItem, Typography } from '@mui/material';
import { t } from 'i18next';
import { AvatarPicker } from '../Users/forms/avatarPicker';
import { creatableUserTypes } from '../../../configs/users';
import { CommonCard } from 'component/cards/MainCard2';
import { CommonSelect } from 'component/select';

const HeaderUserAdd = ({ values, handleChange }) => {
    const typeOptions = creatableUserTypes.map((type) => ({
        value: type.value,
        name: t(type.labelKey)
    }));

    return (
        <CommonCard sx={{ display: 'flex', width: '100%', p: 2 }}>
            <AvatarPicker values={values} handleChange={handleChange} />
            <Box sx={{ width: 32 }}></Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}
            >
                <Typography variant="h5">{t('tableHeaders.type')}</Typography>
                <Box sx={{ height: 8 }}></Box>
                <FormControl sx={{ minWidth: 300 }}>
                    <CommonSelect
                        displayEmpty
                        name="type"
                        value={values.type}
                        onChange={handleChange}
                        size="small"
                        renderValue={(value) => {
                            const selectedOption = typeOptions.find(
                                (option) => option.value === value
                            );
                            return selectedOption ? selectedOption.name : '';
                        }}
                    >
                        {typeOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.name}
                            </MenuItem>
                        ))}
                    </CommonSelect>
                </FormControl>
            </Box>
        </CommonCard>
    );
};

HeaderUserAdd.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};

export default HeaderUserAdd;
